var selectedCountry = $("#country option:selected").val();
function UPSlookup() {
    var isChecked = $("#PostLabel").prop("checked");

    if(isChecked === true){
        switch(selectedCountry){
            case "NO":
                var customerZip = $("#EcomOrderCustomerZip").val();
                    if(customerZip !== "") {
                        $.ajax({
                            url: '/handlers/UpsDelivery.ashx?zip=' + customerZip,
                            dataType: "json",
                            timeout: 10000,
                            success: function (data) {
                                if(data.StatusCode==1) {
                                    //value 4 = UPS
                                    $("#postlabelvalue").val("4");
                                }
                                else {
                                    //value 3 = Bring
                                    $("#postlabelvalue").val("3");
                                }
                            },
                            error: function (request, status, error) {
                                $("#postlabelvalue").val("3");
                                if (request.status === 400) {}
                                if (request.status === 500) {}
                                if (status === "timeout") {
                                    console.log("UpsDelivery timeout");
                                }
                            }
                        });
                    }
            break;

            case "DK":
                $("#postlabelvalue").val("1");
            break;

            case "SE":
                $("#postlabelvalue").val("2");
            break;

            default:
                $("#postlabelvalue").val("");
            break;
        }
    }
    else{
        $("#postlabelvalue").val("");
    }
}